<div class="card">
  <p-table [value]="products" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        @for (col of [].constructor(columns); track col; let last = $last) {
          <th [ngStyle]="{'width': last ? 'calc(100% / (columns * 2))' : 'calc(100% / (columns - 0.5))'}">
            <p-skeleton height="2rem"></p-skeleton>
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product>
      <tr>
        @for (col of [].constructor(columns); track col; let last = $last) {
          <td [ngStyle]="{'width': last ? 'calc(100% / (columns * 2))' : 'calc(100% / (columns - 0.5))'}">
            <p-skeleton height="2rem"></p-skeleton>
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</div>